;(function module() {
  angular.module('app.ui.form.ctrls').controller('DateModalController', [
    '$uibModalInstance',
    '$uibModal',
    'selectedModal',
    '$rootScope',
    'logger',
    'id',

    function controller(
      $uibModalInstance,
      $uibModal,
      selectedModal,
      $rootScope,
      logger,
      id
    ) {
      var vm = this
      $rootScope.$on('application-deleted', (event, {applicationDeleted}) => {
        if (id === applicationDeleted) {
          logger.notify('error', 'Application is Deleted by Other Admin')
          $uibModalInstance.dismiss('cancel')
        }
      })
      $rootScope.$on('position-deleted', (event, {positionDeleted}) => {
        if (Array.isArray(id) && id.find(({id}) => id === positionDeleted)) {
          logger.notify(
            'error',
            'One of the Position selected is Deleted by Other Admin'
          )
          id = id.filter(({id}) => id !== positionDeleted)
          $uibModalInstance.dismiss('cancel')
        }

        if (id === positionDeleted) {
          logger.notify('error', 'Position is Deleted by Other Admin')
          $uibModalInstance.dismiss('cancel')
        }
      })
      vm.selectedModal = angular.copy(selectedModal)

      /** When clicking 'save' button this method will save only selected child practice area from modal
       */
      vm.save = () => {
        $uibModalInstance.close(vm.selectedModal)
      }

      /**  When clicking 'cancel' button this method will closed modal
       */
      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }

      vm.deleteConfirmationPopup = title => {
        const modalInstance = $uibModal.open({
          templateUrl: 'delete-confirmation-modal.html',
          controller: function(title) {
            let vm = this
            vm.title = title
            vm.cancel = () => {
              modalInstance.dismiss('cancel')
            }

            vm.confirmDelete = () => {
              modalInstance.close(true)
            }
          },
          controllerAs: 'ctrl',
          resolve: {
            title: function() {
              return title
            },
          },
        })
        modalInstance.result.then(
          isDeleted => {
            vm.selectedModal.isDeleted = isDeleted
            $uibModalInstance.close(vm.selectedModal)
          },
          () => {}
        )
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/date-modal/date-modal.ctrl.js